export default "__VITE_ASSET__598dc689__"